module.exports = __webpack_public_path__ + "static/media/CAM4-black-white.15aa8de8.png";